
const Whohelped=[
    {
    
         name:'Akash Rahman',
         taka:5000
      
    },
    {
        name:'Mizan Akahas',
        taka:5000
    },
   
   {
    
        name:'Rahman Miah',
        taka:5000
     
   }
     
]

export default Whohelped